import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout';
import MyProfilePage from '@features/profile/MyProfilePage';

export const Route = createFileRoute('/c/$orgId/$portalId/my-account')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <MyProfilePage />
    </UserLayout>
  );
}
